/**
 * DOMI-CARE - Banner de Modo Demo / Evaluación Comercial
 * Se muestra discretamente al cliente cuando el sistema no cuenta con licencia activa.
 * No expone atajos ni referencias al PIN de SuperAdmin.
 */

import { licenseState } from '../state/licenseState.js';
import { notify } from './notificationCenter.js';

export function renderDemoBanner(containerElement) {
  if (!licenseState.isDemo()) {
    containerElement.innerHTML = '';
    containerElement.style.display = 'none';
    return;
  }

  containerElement.style.display = 'block';
  containerElement.innerHTML = `
    <div style="background: linear-gradient(90deg, #1e293b, #0f172a); color: #ffffff; padding: 0.55rem 1.5rem; display: flex; align-items: center; justify-content: space-between; font-size: 0.825rem; border-bottom: 2px solid var(--primary-600); flex-wrap: wrap; gap: 0.75rem;">
      <div style="display: flex; align-items: center; gap: 0.6rem;">
        <span class="badge" style="background: #0284c7; color: #ffffff; font-size: 0.7rem;">MODO DEMO</span>
        <span style="font-weight: 600; color: #e2e8f0;">
          Versión de Evaluación Comercial — Datos y operaciones almacenados en base local del dispositivo.
        </span>
      </div>

      <div style="display: flex; align-items: center; gap: 0.75rem;">
        <button id="btn-reset-demo-data" class="btn btn-secondary btn-sm" style="font-size: 0.75rem; padding: 0.25rem 0.65rem; background: rgba(255,255,255,0.1); color: #ffffff; border-color: rgba(255,255,255,0.2);">
          ↺ Restablecer Datos de Muestra
        </button>
      </div>
    </div>
  `;

  const btnReset = document.getElementById('btn-reset-demo-data');
  if (btnReset) {
    btnReset.addEventListener('click', async () => {
      if (confirm('¿Deseas restablecer los pacientes, escalas y visitas de prueba a sus valores iniciales?')) {
        await licenseState.resetToDemo();
        notify.info('Datos de muestra restablecidos al estado original de evaluación.');
        window.dispatchEvent(new CustomEvent('domicare:refresh-views'));
      }
    });
  }
}
